var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCurier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.211 495.211",
    style: {
      enableBackground: "new 0 0 495.211 495.211"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    d: "M378.969,116.657h-147.34c-9.328,0-16.876,7.551-16.876,16.87v38.996l53.148,9.22 c17.993,3.124,30.045,20.236,26.916,38.21c-3.111,17.983-20.232,30.039-38.207,26.916l-41.857-7.261v12.329 c0,9.319,7.547,16.87,16.876,16.87h147.34c9.31,0,16.864-7.551,16.864-16.87v-118.41 C395.833,124.208,388.279,116.657,378.969,116.657z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_405_",
    d: "M173.638,232.468c-8.972-1.567-15.716-8.504-17.489-16.919l-10.217-49.145l21.349,43.704 c2.902,5.957,8.505,10.151,15.04,11.28l76.419,13.264c1.191,0.212,2.387,0.307,3.547,0.307c9.861,0,18.587-7.076,20.331-17.121 c1.938-11.239-5.579-21.936-16.808-23.882l-66.031-11.463l-16.716-34.217l17.244,20.331v-21.147 c0-22.961-18.619-41.583-41.581-41.583h-17.748c-22.981,0-41.601,18.622-41.601,41.583v112.131l0.209,210.836 c0,13.691,11.089,24.783,24.786,24.783c13.703,0,24.786-11.092,24.786-24.783V322.726h16.526v147.702 c0,7.146-1.988,13.762-5.18,19.628c4.18,3.188,9.322,5.155,14.986,5.155c13.703,0,24.785-11.092,24.785-24.783l0.031-233.329 l-20.116-3.495L173.638,232.468z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_404_",
    d: "M149.852,96.585c26.658,0,48.277-21.616,48.277-48.289C198.129,21.616,176.51,0,149.852,0 c-26.688,0-48.314,21.616-48.314,48.296C101.538,74.968,123.164,96.585,149.852,96.585z",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurier);
export default __webpack_public_path__ + "static/media/icon-curier.53929b16af30c16286feb1253066079e.svg";
export { ForwardRef as ReactComponent };